export default __webpack_public_path__ + "static/media/scdream6.b4ff8d49.woff2";